
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSpeedGood as ObiSpeedGoodElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-speed-good.js';
 
 
 

 
 export const ObiSpeedGood = createComponent({
   react: React,
   tagName: 'obi-speed-good',
   elementClass: ObiSpeedGoodElement,
   events: {
     
   }
  });
 
 